import { t } from '../../i18n';
// admin-client/src/components/lounge/LoungeItemCard.jsx
import React from 'react';
import { getLoungeCategoryLabel } from '../../api/loungeApi';
const statusLabelMap = {
    draft: t("\uCD08\uC548"),
    published: t("\uAC8C\uC2DC \uC911"),
    paused: t("\uC911\uC9C0\uB428"),
    deleted: t("\uC0AD\uC81C\uB428"),
};
function fmtDate(value) {
    if (!value)
        return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime()))
        return '-';
    return d.toLocaleString();
}
function isExpired(value) {
    if (!value)
        return false;
    const d = new Date(value);
    return !Number.isNaN(d.getTime()) && d.getTime() <= Date.now();
}
export default function LoungeItemCard({ item, onClick, onPublish, onPause, onDelete, canEdit = true, canPublish = true, canDelete = true }) {
    const status = item?.status || 'draft';
    const isPublished = status === 'published';
    const isDeleted = status === 'deleted';
    const expired = isExpired(item?.publishEndAt || item?.expiredAt);
    return (<div role={canEdit ? "button" : undefined} tabIndex={canEdit ? 0 : undefined} onClick={canEdit ? onClick : undefined} onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ')
                if (canEdit) onClick?.();
        }} className="w-full text-left rounded-xl border border-gray-200 shadow-sm bg-white overflow-hidden hover:shadow transition">
      <div className="flex flex-col sm:flex-row gap-4 p-4 sm:p-5">
        <div className="w-full sm:w-36 h-36 sm:h-24 shrink-0 rounded-lg bg-gray-100 overflow-hidden border border-gray-200 flex items-center justify-center">
          {item.thumbnailUrl ? (<img src={item.thumbnailUrl} alt="" className="w-full h-full object-cover"/>) : (<span className="text-gray-400 text-2xl">🖼️</span>)}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
            <div>
              <div className="text-xl font-extrabold text-gray-900 truncate">{item.title || t("(\uC81C\uBAA9 \uC5C6\uC74C)")}</div>
              <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
                <span className="px-2 py-1 rounded bg-yellow-100 text-yellow-800 font-semibold">
                  {getLoungeCategoryLabel(item.category)}
                </span>
                <span className={[
            'px-2 py-1 rounded font-semibold',
            isPublished ? 'bg-emerald-100 text-emerald-700' : status === 'paused' ? 'bg-gray-200 text-gray-700' : 'bg-blue-100 text-blue-700',
        ].join(' ')}>
                  {statusLabelMap[status] || status}
                </span>
                <span className="px-2 py-1 rounded bg-gray-100 text-gray-600">
                  {item.isPaid ? t("\uACB0\uC81C \uC644\uB8CC") : t("\uBBF8\uACB0\uC81C")} · {Number(item.uploadFee || 60).toLocaleString()} USDT / {Number(item.periodDays || 30)}{t("\uC77C")}</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 shrink-0">
              {canPublish && (status === 'draft' || status === 'paused') ? (<button type="button" onClick={(e) => {
                e.stopPropagation();
                onPublish?.(item);
            }} className="px-4 py-2 rounded-md bg-yellow-400 hover:bg-yellow-500 text-black text-sm font-semibold disabled:opacity-50" disabled={isDeleted}>
                  {status === 'draft' ? t("\uC5C5\uB85C\uB4DC") : t("\uC7AC\uAC8C\uC2DC")}
                </button>) : null}

              {canPublish && status === 'published' ? (<button type="button" onClick={(e) => {
                e.stopPropagation();
                onPause?.(item);
            }} className="px-4 py-2 rounded-md bg-gray-500 hover:bg-gray-600 text-white text-sm font-semibold">{t("\uC911\uC9C0")}</button>) : null}

              {canDelete && <button type="button" onClick={(e) => {
            e.stopPropagation();
            onDelete?.(item);
        }} className="px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white text-sm font-semibold disabled:opacity-50" disabled={isDeleted}>{t("\uC0AD\uC81C")}</button>}
            </div>
          </div>

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 text-xs text-gray-500 break-words">
            <div>{t("\uC791\uC131\uC77C:")}{fmtDate(item.createdAt)}</div>
            <div>{t("\uAC8C\uC2DC\uC77C:")}{fmtDate(item.publishedAt)}</div>
            <div>{t("\uB9CC\uB8CC\uC77C:")}{fmtDate(item.publishEndAt || item.expiredAt)}{expired ? t(" \u00B7 \uB9CC\uB8CC\uB428") : ''}</div>
            <div>PostCode: {item.postCode || '-'}</div>
          </div>
        </div>
      </div>
    </div>);
}
